export default __webpack_public_path__ + "static/media/img-logo-slack.021f1acb.svg";